module.exports = __webpack_public_path__ + "img/login.47da2976.png";